import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=7c83ba94&scoped=true&"
import script from "./PrivacyNotice.vue?vue&type=script&lang=ts&"
export * from "./PrivacyNotice.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=7c83ba94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c83ba94",
  null
  
)

export default component.exports